import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';
import { validatePhone } from 'src/app/utils/string';

@Component({
  selector: 'app-update-self-phone-dialog',
  templateUrl: './update-self-phone-dialog.component.html',
  styleUrls: ['./update-self-phone-dialog.component.scss'],
})
export class UpdateSelfPhoneDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UpdateSelfPhoneDialogComponent>,
    private api: UserApiService,
    private message: MessageService,
    private user: UserService
  ) {}

  phone = '';
  code = '';

  loading = false;

  timeout = 0;

  sendCode(e: any) {
    e.stopPropagation();

    this.phone = this.phone.trim();
    if (!this.phone || !validatePhone(this.phone)) {
      this.message.warn('请输入有效的手机号');
      return;
    }
    this.sendUpdatePhoneCode(this.phone);
  }

  async sendUpdatePhoneCode(phone: string) {
    if (this.timeout > 0 || this.loading) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.api.sendUpdatePhoneCode(phone);
      if (r.status === 1002) {
        this.message.open('账号已封禁，无法登录');
      } else if (r.status === 1004) {
        this.message.open('手机号未修改，请填写新手机号');
      } else if (r.status === 1005) {
        this.message.warn('手机号已被使用');
      } else if (r.status === 1001) {
        this.timeout = r.data;
        this.message.open('发送过快');
      } else if (r.status === 1000) {
        this.message.open('发送失败');
      } else if (r.status !== 0) {
        this.message.open('未知错误');
      } else {
        this.timeout = r.data;
      }
      this.tick();
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  tick() {
    if (this.timeout <= 0) {
      return;
    }
    var i = setInterval(() => {
      this.timeout -= 1;
      if (this.timeout <= 0) {
        clearInterval(i);
      }
    }, 1000);
  }

  onOk() {
    this.phone = this.phone.trim();
    this.code = this.code.trim();
    if (!this.phone || !this.code || this.loading) {
      return;
    }

    if (!validatePhone(this.phone)) {
      this.message.warn('请输入有效的手机号');
      return;
    }
    this.updateSelfPhone(this.phone, this.code);
  }

  async updateSelfPhone(phone: string, code: string) {
    try {
      this.loading = true;
      const r = await this.api.updateSelfPhone(phone, code);
      if (r.status === 1003) {
        this.message.warn('验证码错误');
      } else if (r.status === 1005) {
        this.message.warn('手机号已被使用');
      } else if (r.status !== 0) {
        this.message.warn('未知错误');
      } else {
        this.message.open('更新成功');
        this.user.setSelf(r.data);
        this.dialogRef.close();
      }
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }
}
